import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const CanonicalUrl = ({ href }) => {
  const { pathname } = useLocation();
  const canonical = href || `https://streamily.com${pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
};

CanonicalUrl.propTypes = {
  href: PropTypes.string,
};

export default CanonicalUrl;
